/**
 *
 *
 * @returns 返回值 1：微信 2：非微信
 */
const isWeiXin = () => {
    const ua: any = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    } else {
        return false;
    }
}

/**
 *
 *
 * @param {*} getLocation 回调函数：返回值是位置坐标
 */
const getlocationpoint = (getLocation) => {
    if (navigator.geolocation) {
        let latitude, longitude;
        navigator.geolocation.getCurrentPosition(
            function (position) {

                latitude = position.coords.latitude;//获取纬度
                longitude = position.coords.longitude;//获取经度
                getLocation([latitude, longitude])
            }
        );

    } else {
        getLocation([]);
    }
}
/*获取地址栏参数*/
const getParam = (name) => {
    var theRequest = {};
    if (window.location.href.indexOf("?") != -1) {
        var url = window.location.href.split("?")[1];
        var strs = url.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
    }
    if (theRequest[name] && theRequest[name] != 'null') {
        return theRequest[name];
    } else {
        return null;
    }
}
// 判断是否是安卓
const isAndroid = () => {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    if (isAndroid) {
        return Promise.resolve('安卓系统');
    } else {
        return Promise.reject('IOS系统');
    }
}

// 判断是否是安卓
/**
 *
 *
 * @param {*} file 文件流
 * @param {number} [scale=0.92] 缩放比例默认0.92
 * @param {number} [maxWidth=300] 最大宽度 默认 300
 * @param {number} [maxHeight=300] 最大高度 默认300
 * @param {string} [urlType='blob'] 处理完成后img的url类型 默认是blob
 */
const imageCompress = (file, maxSize = 10 * 1024, scale = 0.92, maxWidth = 300, maxHeight = 300, urlType = 'blob') => {

    return new Promise((resolve, reject) => {
        if (file.type.indexOf("image") === 0) {
            if (file.size < 2 * 1024) {
                resolve(file);
            }
            if (file.size > maxSize * 1024) {
                reject(`照片过大，建议${maxSize / 1024}M以下，请换张照片或手动输入`);
            } else {
                // 压缩图片需要的一些元素和对象
                var reader = new FileReader(),
                    //创建一个img对象
                    img = new Image();

                reader.readAsDataURL(file);
                // 文件base64化，以便获知图片原始尺寸
                reader.onload = function (e) {
                    let dom: any = e.target
                    img.src = dom.result;
                };

                // base64地址图片加载完毕后执行
                img.onload = function () {
                    // 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
                    var canvas = document.createElement('canvas');
                    var context: any = canvas.getContext('2d');
                    let _this: any = this;
                    // 图片原始尺寸

                    var originWidth: any = _this.width;
                    var originHeight: any = _this.height;
                    console.log(originHeight)

                    // 最大尺寸限制，可通过设置宽高来实现图片压缩程度
                    // 目标尺寸
                    var targetWidth = originWidth,
                        targetHeight = originHeight;
                    // 图片尺寸超过300x300的限制
                    if (originWidth > maxWidth || originHeight > maxHeight) {
                        if (originWidth / originHeight > maxWidth / maxHeight) {
                            // 更宽，按照宽度限定尺寸
                            targetWidth = maxWidth;
                            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                        } else {
                            targetHeight = maxHeight;
                            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                        }
                    }
                    // canvas对图片进行缩放
                    canvas.width = targetWidth;
                    canvas.height = targetHeight;
                    // 清除画布

                    context.clearRect(0, 0, targetWidth, targetHeight);
                    // 图片压缩
                    context.drawImage(img, 0, 0, targetWidth, targetHeight);
                    /*第一个参数是创建的img对象；第二三个参数是左上角坐标，后面两个是画布区域宽高*/

                    //压缩后的图片转base64 url
                    /*canvas.toDataURL(mimeType, qualityArgument),mimeType 默认值是'image/png';
                    * qualityArgument表示导出的图片质量，只有导出为jpeg和webp格式的时候此参数才有效，默认值是0.92*/
                    //var newUrl = canvas.toDataURL('image/jpeg', 0.92);//base64 格式
                    //也可以把压缩后的图片转blob格式用于上传


                    // if (urlType == 'blob') {
                    //     var dataURL = canvas.toDataURL('image/jpeg', scale);

                    //     var blobBin: any = atob(dataURL.split(',')[1]);
                    //     var array = new Array();
                    //     for (var i = 0; i < blobBin.length; i++) {
                    //         array.push(blobBin.charCodeAt(i));
                    //     }
                    //     var file = new Blob([new Uint8Array(array)], {type: 'image/jpeg'});
                    //     console.log(file);
                    //     resolve(file);

                    // } else {
                    //     let base64Url = canvas.toDataURL('image/jpeg', scale);//base64 格式
                    //     resolve(base64Url);
                    // }

                    let base64Url = canvas.toDataURL('image/jpeg', scale);//base64 格式
                    const blob = dataURItoBlob(base64Url);
                    resolve(blob);

                };
            }

        } else {
            reject('请选择图片文件');
        }
    })


}

function dataURItoBlob(base64Data) {
    //console.log(base64Data);//data:image/png;base64,
    var byteString;
    if (base64Data.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(base64Data.split(',')[1]);//base64 解码
    else {
        byteString = unescape(base64Data.split(',')[1]);
    }
    var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];//mime类型 -- image/png

    // var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
    // var ia = new Uint8Array(arrayBuffer);//创建视图
    var ia = new Uint8Array(byteString.length);//创建视图
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    var blob = new Blob([ia], {
        type: mimeString
    });
    return blob;
}

const iswebp = () => {
    return document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0
}


const dateFormat = (str: string, type?: string): string => {
    let year: string = str.substring(0, 4);
    let month: string = str.substring(5, 7);
    let strDate: string = str.substring(8, 10);
    let hours: string = str.substring(11, 13);
    let minute: string = str.substring(14, 16);
    let second: string = str.substring(17, 19);
    // let date = new Date(str);
    // let month: string | number = date.getMonth() + 1;
    // let strDate: string | number = date.getDate();
    // let hours: string | number = date.getHours();
    // let minute: string | number = date.getMinutes();
    // let second: string | number = date.getSeconds();

    // if (month <= 9) {month = "0" + month;}
    // if (strDate <= 9) {strDate = "0" + strDate;}
    // if (hours <= 9) {hours = "0" + hours;}
    // if (minute <= 9) {minute = "0" + minute;}
    if (type === null) {
        return year + "-" + month + "-" + strDate + " "
            + hours + ":" + minute;
    } else {
        switch (type) {
            case 'year': return year + "";
            case 'day': return year + "-" + month + "-" + strDate;
            case 'minute': return year + "-" + month + "-" + strDate + " " + hours + ":" + minute;
            case 'second': return year + "-" + month + "-" + strDate + " " + hours + ":" + minute + ":" + second;
            default: return year + "-" + month + "-" + strDate + " " + hours + ":" + minute;
        }
    }
};

const getTaxCondition = (code: string) => {
    let result: string = '';
    switch (code) {
        case 'T': result = '纳税'; break;
        case 'E': result = '免税'; break;
        case 'C': result = '减税'; break;
        case 'P': result = '已完税'; break;
        case 'R': result = '拒缴'; break;
        case 'B': result = '补税'; break;
        default: result = '';
    }
    return result;
}

const getInsureTypeName = (code: string) => {
    let result: string = '';
    switch (code) {
        case "TPL": result = '机动车第三者责任保险'; break;
        case "MH": result = '车辆损失险'; break;
        case "DL": result = '车上人员责任保险（司机）'; break;
        case "PL": result = '车上人员责任保险（乘客）'; break;
        case "TR": result = '机动车全车盗抢保险'; break;
        case "GB": result = '玻璃单独破碎险'; break;
        case "LBS": result = '车身划痕损失险'; break;
        case "SLE": result = '发动机涉水损失险'; break;
        case "SC": result = '自燃损失险'; break;
        case "NTPL": result = '无法找到第三方特约险'; break;
        case "SRF": result = '指定修理厂险'; break;
        case "WDAC": result = '附加险不计免赔特约险'; break;
        case "MWWD": result = '车轮单独损坏除外特约险'; break;
        case "DTPL": result = '第三者责任保险节假日限额翻倍险'; break;
        case "CTPL": result = '交强险'; break;
    }
    return result;
};

const getIdType = (code: string) => {
    let result: string = '';
    switch (code) {
        case 'ID': result = '居民身份证'; break;
        case '02': result = '居民户户口簿'; break;
        case '03': result = '驾驶证'; break;
        case 'MC': result = '军人证'; break;
        case '05': result = '士兵证'; break;
        case '06': result = '军官离退休证'; break;
        case 'PP': result = '中国护照'; break;
        case '08': result = '异常身份证'; break;
        case 'HM': result = '港澳居民来往内地通行证'; break;
        case 'TP': result = '台湾居民来往内地通行证'; break;
        case '43': result = '回乡证'; break;
        case '51': result = '外国护照'; break;
        case '52': result = '旅行证'; break;
        case '53': result = '居留证件'; break;
        case 'FD': result = '外国人永久居留身份证'; break;
        case 'USCD': result = '统一社会信用代码'; break;
        case 'BLN': result = '营业执照号码'; break;
    }
    return result;
}

const refreshTtile = (title: string) => {
    setTimeout(function () {
        //利用iframe的onload事件刷新页面
        document.title = title;
        let iframe = document.createElement('iframe');
        iframe.style.visibility = 'hidden';
        iframe.style.width = '1px';
        iframe.style.height = '1px';
        iframe.onload = function () {
            setTimeout(function () {
                document.body.removeChild(iframe);
            }, 0);
        };
        document.body.appendChild(iframe);
    }, 0);
}

const phoneDes = (str: string) => {
    let pat = /(\d{3})\d*(\d{4})/;
    return str.replace(pat, '$1****$2');
}

const idCodeDes = (str: string) => {
    let pat = /(\d{4})\d*(\d{2})/;
    return str.replace(pat, '$1***************$2');
}

const nameDes = (str: string) => {
    let length = str.length;
    let ruten;
    switch (length) {
        case 2: ruten = str.substring(0, 1); break;
        case 3: ruten = str.substring(1, 2); break;
        default: ruten = str.substring(1, 3); break;
    }
    return str.replace(ruten, '*');
}

const plateDes = (str: string) => {
    let pre = str.substring(0, 2);
    let after = str.substring(5, 7);
    return pre + '***' + after;
}

/**
 * 阿拉伯数字转换
 * @param str
 */
const numberChinese = (str) => {
    // let num = parseInt(str);
    let num = str;
    let strOutput = "",
        strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分';
    num += "00";
    let intPos = num.indexOf('.');
    if (intPos >= 0) {
        num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
    }
    strUnit = strUnit.substr(strUnit.length - num.length);
    for (let i = 0; i < num.length; i++) {
        strOutput += '零壹贰叁肆伍陆柒捌玖'.substr(num.substr(i, 1), 1) + strUnit.substr(i, 1);
    }
    return strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元")

}

//js处理脱敏的方法
const Desensitization = (str, beginLen, endLen) => {
    const len = str.length;
    const firstStr = str.substr(0, beginLen);
    const lastStr = str.substr(endLen);
    const middleStr = str.substring(beginLen, len - Math.abs(endLen)).replace(/[\s\S]/ig, '*');
    const tempStr = firstStr + middleStr + lastStr;
    return tempStr;
}

//信息确认页的姓名脱敏(客服版用到)
const nameDesensitization = (name) => {
    const str = name[0] + name.slice(1).replace(/[\s\S]/ig, '*');
    return str;
}

//信息确认页的邮箱脱敏(客服版用到)
const emailDesensitization = (email) => {
    const emailArr = email.split('@');
    const prefix = Desensitization(emailArr[0], 1, -1);
    const suffix = emailArr[1];
    const tempStr = prefix + '@' + suffix;
    return tempStr;
}

//计算元素距离顶部的高度
const getElementTop = (el) => {
    if (!el) return;
    let actualTop = el.offsetTop;
    let current = el.offsetParent;
    while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
    }
    return actualTop;
}

const getDocumentScrollTop = () => {
    return document.documentElement.scrollTop || document.body.scrollTop;
}

const zero = (e) => {
    return e < 10 ? "0" + e : e;
}

const getDateStr = () => {
    let e = new Date(Date.now());
    return `${e.getFullYear()}${zero(e.getMonth() + 1)}${zero(e.getDate())}`;
}

//获取页面高度
const getDocumentHeight = () => {
    return document.documentElement.clientHeight || document.body.clientHeight;
}

// 判断设备类型
const judgeDeviceType = function () {
    var ua = window.navigator.userAgent.toLocaleLowerCase();
    var isIOS = /iphone|ipad|ipod/.test(ua);
    var isAndroid = /android/.test(ua);
    return {
        isIOS: isIOS,
        isAndroid: isAndroid
    }
}()

const judgeHuaWei = () => {
    const agent = navigator.userAgent.toLowerCase();
    let isHuawei = agent.match(/huawei/i) == 'huawei';
    let isHonor = agent.match(/honor/i) == 'honor';
    console.log('agent-agent', agent);
    console.log('isHuawei-isHuawei', isHuawei);
    console.log('isHonor-isHonor', isHonor);
    //用huaweibrowser来判断是华为自带浏览器huaweioem
    if (isHuawei || isHonor) {
        if (agent.indexOf('huaweibrowser') > -1 || agent.indexOf('huaweioem') > -1) {
            return 'huawei';
        } else {
            return '';
        }
    } else {
        return '';
    }
}

const getSpecialParam = (name: string) => {
    const homeUrl = window.location.href;
    const hash = new URL(homeUrl).hash;
    const questionMarkArr = hash.split('?');
    const paramsObj = {};
    if (questionMarkArr && questionMarkArr.length && questionMarkArr.length > 1) {
        const paramsStr = questionMarkArr[questionMarkArr.length - 1];
        const paramsStrArr = paramsStr.split('&');
        if (paramsStrArr && paramsStrArr.length) {
            paramsStrArr.forEach(item => {
                if (item && item.split('=') && item.split('=').length) {
                    const newKey = item.split('=')[0];
                    const newValue = item.split('=')[1];
                    if (newKey) {
                        paramsObj[newKey] = newValue || '';
                    }
                }
            })
        }
    }
    if (paramsObj && Object.keys(paramsObj) && Object.keys(paramsObj).length) {
        return paramsObj[name] || '';
    } else {
        return '';
    }
}

const getFirstAnswer = () => {
    let firstAnswer = '';
    if (localStorage.getItem('systemSource') === 'ZJ_YGJJ') {
        firstAnswer = `目前网上仅支持9座以下个人非营业客车报价及投保。投保城市目前仅限广东省全辖范围（不含深圳市）。`;
    } else if (localStorage.getItem('systemSource') === 'JD_JCH') {
        firstAnswer = `目前网上仅支持9座以下个人非营业客车报价及投保。投保城市目前仅限北京市、四川省。`;
    } else {
        const systemSource = localStorage.getItem('systemSource') || "";
        firstAnswer = `目前网上仅支持9座以下个人非营业客车报价及投保。投保城市目前仅限广东省全辖范围${(
            ["JD_POP", "JD_PLUS", "JD_POP2", "JD_ME", "JD_PROGRAM"].includes(systemSource)
        ) ? '（不含深圳市）、' : '、上海市、'}北京市、四川省。`;
    }
    return firstAnswer;
}


/**
 * 判断是否是京ME环境
 */
const isJDME = () => {
    if (window && window.navigator) {
        return navigator.userAgent.indexOf('JDME') !== -1;
    }
    return false;
};

// 京东ME erp 登录跳转 
const jdmeLogin = () => {
    if (
        isJDME()
    ) {
        let cookiePath = '/proxy/3rd/client/cookie/write'
        let apiUrl = `https://claim.az.jd.com/3rd/client/cookie/redirect?c=third_name,third_safetyToken,third_timestamp&check=true&path=${cookiePath}&redirect=true&to=`
        let targetUrl = window.location.href
        if (targetUrl.indexOf('?') > 0) {
            let urlData = window.location.href.split('?')
            let params = ''
            try {
                urlData[1].split('&').map((item) => {
                    if (!item.startsWith('third_') && !item.startsWith('_p_')) {
                        params += `&${item}`
                    }
                })
            } catch (e) {

            }   
            targetUrl = `${urlData[0]}?${params}`
            targetUrl = targetUrl.replace('&', '')
        }
        // console.log('targetUrl',targetUrl)
        let redirectUrl = `${apiUrl}${encodeURIComponent(targetUrl)}`
        let deepLink = `jdme://web/201812060354?url=${encodeURIComponent(redirectUrl)}`
        // @ts-ignore
        // 关闭当前窗口 
        // 跳转到京me的窗口
        // debugger
        window.jme.browser.callDeepLink({
            url: deepLink,
            callback: function (res) {
                console.log('jme.browser.callDeepLink', res)
                // 登录返回 
            }
        })

    }
}

/**
 *
 * @description 获取cookie中　特定 key 的值
 * @param {string} key
 *
 */

const getCookieKey = (key: string) => {
    // 获取所有的cookie 键值对 
    const cookieArr = document.cookie.split(';');
    let cookieMap = new Map();
    cookieArr.forEach(function(item, idx){
        const [key, keyValue] = item.split('='); 
        cookieMap.set(key.trim(), keyValue.trim())
    });
    return cookieMap.get(key) || '';
}


export {
    plateDes,
    getTaxCondition,
    numberChinese,
    nameDes,
    idCodeDes,
    phoneDes,
    isWeiXin,
    getlocationpoint,
    getParam,
    isAndroid,
    imageCompress,
    iswebp,
    dateFormat,
    getInsureTypeName,
    getIdType,
    refreshTtile,
    Desensitization,
    nameDesensitization,
    emailDesensitization,
    getElementTop,
    getDocumentScrollTop,
    getDateStr,
    getDocumentHeight,
    judgeDeviceType,
    judgeHuaWei,
    getSpecialParam,
    getFirstAnswer,
    jdmeLogin,
    getCookieKey
}
